import { useMe } from '@crehana/auth';
import type { TToDoList } from '@crehana/compass.dashlets';
import { useTranslation } from '@crehana/i18n';

import { useGetTodoListV2Query } from './graphql/get-to-do-list-v2.v5.generated';

export const useGetTodoList = () => {
  const { languageCode } = useTranslation();
  const { me, talentUser } = useMe();

  const { loading, error, data, refetch } = useGetTodoListV2Query({
    variables: {
      input: {
        company_id: talentUser.company_id_talent,
        user_email: me?.email,
      },
    },
    context: {
      clientName: 'v5',
      credentials: 'omit',
      headers: {
        'Language-Code': languageCode,
      },
    },
    skip: !me?.email || !talentUser.company_id_talent,
  });

  return {
    loading: loading || me?.loading || talentUser.loading,
    error,
    refetch,
    dataTodoList: data?.talent.talent_dashboard.talent_dashboard_collaborator
      .get_talent_dashboard_collaborator_todo_list as TToDoList,
  };
};
